export default {
  languages: [],
  pagination: {},
  language: {}
}
